import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/shared/components/icon';
import Popover from 'src/shared/components/popover';
export function PopoverButton({ onClick, action }) {
    const { t } = useTranslation();
    if (action === 'change') {
        return (_jsx(Popover.Button, { onClick: onClick, className: "border-neutral-300 text-neutral-500", children: _jsxs("span", { className: "flex items-center gap-2", children: [_jsx(Icon, { icon: faImage, className: "text-medium" }), t('upload_file.edit_image')] }) }));
    }
    return (_jsx(Popover.Button, { onClick: onClick, className: "bg-neutral-600 text-neutral-0", children: t('upload_file.add_image') }));
}
